<template>
  <a-menu
    mode="inline"
    theme="dark"
    :selected-keys="[current]"
    @click="handleClick"
    >

    <a-menu-item
      @click="navigateTo({name: 'planner'})"
      key="planner"
      >
      <a-icon type="calendar" />
      <span>Planner</span>
    </a-menu-item>

    <a-sub-menu>
      <span slot="title">
        <a-icon type="appstore" />
        <span>Boards</span>
      </span>

      <a-menu-item
        v-for="board in boards"
        :key="board.id"
        @click="navigateTo({name: 'board', params: {boardId: board.id}})"
      >
        <a-icon type="bars" />
        <span>{{ board.boardName }}</span>
      </a-menu-item>
      <a-menu-item key="newBoard">
        <a-icon type="plus" />
        <span
          @click="createBoard()"
          >
          New Board
        </span>
      </a-menu-item>

    </a-sub-menu>

    <a-sub-menu>
      <span slot="title">
        <a-icon type="user" />
        <span>User</span>
      </span>

      <a-menu-item
        @click="navigateTo({name: 'userAccount'})"
        key="account"
        >
        <a-icon type="solution" />
        <span>Account</span>
      </a-menu-item>
      <a-menu-item
        @click="navigateTo({name: 'userPreferences'})"
        key="preferences"
        >
        <a-icon type="tool" />
        <span>Preferences</span>
      </a-menu-item>
      <a-menu-item
        @click="onLogout"
        key="logout"
        >
        <a-icon type="poweroff" />
        <span>Logout</span>
      </a-menu-item>
    </a-sub-menu>

    <a-menu-item
      @click="navigateTo({name: 'help'})"
      key="help"
      >
      <a-icon type="question-circle" />
      <span>Help</span>
    </a-menu-item>
  </a-menu>
</template>


<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    name: "SideMenu",
    computed: {
      boards() {
        let boards = this.$store.state.boards.boards;
        return Object.keys(boards).map((key) => {
          return {id: key, boardName: boards[key].boardName}
        }).sort((a, b) => a.boardName.localeCompare(b.boardName));
      }
    },
    data() {
      return {
        // initial active sidebar link assumes that key of
        // a-menu-item is equal to the last part of the route
        current: this.$router.currentRoute.path.substring(
          this.$router.currentRoute.path.lastIndexOf('/') + 1
        )
      }
    },
    created() {
      this.$store.dispatch('boards/fetchBoards');
    },
    methods: {
      handleClick(e) {
        this.current = e.key;
      },
      onLogout() {
        firebase.auth().signOut().then(() => {
          this.$router.push("/");
          location.reload();
        })
      },
      createBoard() {
        this.$store.dispatch('boards/createBoard')
          .then(({id}) => {
            this.current = id;
            this.navigateTo({name: 'board', params: {boardId: id}})
          })
      },
      navigateTo(obj) {
        this.$router.push(obj);
      }
    }
}
</script>

<style scoped>

</style>

